import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { Label } from '../KeyComponents';
import DatePicker from '../DatePicker';

function DatePickerDropdown(props) {
  const {
    date, handleDateChange, closeDatePicker, defaultDate
  } = props;

  return (
    <Dropdown.Menu>
      <DatePicker
        date={new Date(date).toISOString()}
        setDate={handleDateChange}
        onSubmit={() => { closeDatePicker(); }}
        onCancel={() => {
          closeDatePicker(); handleDateChange(defaultDate);
        }}
      />
    </Dropdown.Menu>
  );
}

function TextInputDate(props) {
  const {
    label, state: componentState, size, required, defaultDate, className
  } = props;
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [filled, setFilled] = useState(false);
  const [selectedDate, setSelectedDate] = useState(defaultDate || new Date());

  useEffect(() => {
    setSelectedDate(defaultDate || new Date());
  }, [defaultDate]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setFilled(true);
  };

  const closeDatePicker = () => {
    setShowDatePicker(false);
  };

  const toggleDatePicker = (state) => {
    if (componentState !== 'disabled' && componentState !== 'readonly') {
      setShowDatePicker(state);
    }
  };

  return (
    <div
      className={classNames(
        'pgn__text-date-wrapper',
        { 'pgn__text-date-wrapper-filled': filled },
        `pgn__text-date-wrapper-${size}`,
        `pgn__text-date-wrapper-${componentState}`,
        className
      )}
    >
      {label && <Label label={label} required={required} />}
      <Dropdown onToggle={toggleDatePicker} show={showDatePicker}>
        <Dropdown.Toggle className="png__text-date-field">
          <span className="pgn__text-input-date-text">
            {`${selectedDate.getDate().toString().padStart(2, '0')} / ${(selectedDate.getMonth() + 1).toString().padStart(2, '0')} / ${selectedDate.getFullYear()} - ${selectedDate.getHours().toString().padStart(2, '0')}:${selectedDate.getMinutes().toString().padStart(2, '0')} ${selectedDate.getHours() >= 12 ? 'PM' : 'AM'}`}
          </span>
        </Dropdown.Toggle>
        <DatePickerDropdown
          closeDatePicker={closeDatePicker}
          defaultDate={defaultDate}
          date={selectedDate}
          handleDateChange={handleDateChange}
        />
      </Dropdown>
    </div>
  );
}

DatePickerDropdown.propTypes = {
  closeDatePicker: PropTypes.func,
  defaultDate: PropTypes.instanceOf(Date),
  date: PropTypes.instanceOf(Date),
  handleDateChange: PropTypes.func,
};

DatePickerDropdown.defaultProps = {
  closeDatePicker: () => { },
  defaultDate: new Date(),
  date: new Date(),
  handleDateChange: () => { },
};

TextInputDate.defaultProps = {
  size: 'md',
  state: 'default',
  label: '',
  required: false,
  defaultDate: new Date(),
  className: '',
};

TextInputDate.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  state: PropTypes.oneOf(['default', 'error', 'disabled', 'readonly']),
  label: PropTypes.string,
  required: PropTypes.bool,
  defaultDate: PropTypes.instanceOf(Date),
  className: PropTypes.string,
};

export default TextInputDate;
